import React from 'react';

const ContextSiteData = React.createContext (null);

export default ContextSiteData;
